export function isEmpty(value: unknown): boolean {
  // null or undefined
  if (value == null) {
    return true;
  }

  // Arrays and strings - check length
  if (Array.isArray(value) || typeof value === "string") {
    return value.length === 0;
  }

  // Maps and Sets - check size
  if (value instanceof Map || value instanceof Set) {
    return value.size === 0;
  }

  // Objects - check if it has own enumerable properties
  if (typeof value === "object") {
    return Object.keys(value).length === 0;
  }

  // For everything else (numbers, booleans, etc.)
  return false;
}
